import { gql } from "@apollo/client";

export const GetAuthDetailsByToken = gql`
  query GetAuthDetailsByToken($token: String!) {
    GetAuthDetailsByToken(token: $token) {
      id
      authUserID
      mobileNo
      authGroupType
      authIsActive
      authIsBlocked
      firebaseID
      customerID
    }
  }
`;

export const GetEduateDetailsByAuthId = gql`
  query GetEduateDetailsByAuthId($token: String!, $auth_id: ID!) {
    GetEduateDetailsByAuthId(token: $token, auth_id: $auth_id) {
      id
      firstName
      middleName
      lastName
      address
      place
      state
      pin
      email
      mobile
      rights
      lastAccessed
      userType
    }
  }
`;
